module.exports = __webpack_public_path__ + "media/images/icons/outlined/paper-clip-449bf9dbaf27c95447138beafc131752.svg";